export const SequenceTimingType = Object.freeze({
  SERIAL: "serial",
  PARALLEL: "parallel",
  OVERLAP: "overlap" // TODO: Overlap timing
});
